<template>
    <section>
        <div class="bg-green-500">
            <Container>
                    <div class="hidden md:flex items-center h-10 truncate" vocab="https://schema.org/" typeof="BreadcrumbList">
                        <Link class="text-sm text-black font-bold mt-0.5" href="/">Головна</Link>
                        <template v-for="(breadcrumb, key) in items">
                            <Chevron class="mx-2 h-2"/>
                            <span property="itemListElement" typeof="ListItem" class="mt-0.5">
                                <Link
                                    v-if="key !== items.length - 1"
                                    class="text-sm text-black font-bold"
                                    property="item"
                                    typeof="WebPage"
                                    :href="breadcrumb.url"
                                >
                                    <span property="name">{{ breadcrumb.title }}</span>
                                </Link>
                                <span v-else class="text-sm text-indigo-500 font-bold" property="name">
                                    {{ breadcrumb.title }}
                                </span>
                                <meta property="position" :content="key + 1">
                            </span>
                        </template>
                    </div>

                    <div class="md:hidden flex items-center h-10 py-2">
                        <Chevron class="rotate-180 mr-2 h-2"/>
                        <Link
                            class="text-sm text-black font-bold mt-1"
                            :href="items[items.length - 2]?.url || '/'"
                        >
                            {{ items[items.length - 2]?.title || 'Головна' }}
                        </Link>
                    </div>
            </Container>
        </div>
    </section>
</template>

<script>
import {Link} from '@inertiajs/vue3';
import Chevron from "@/Components/Svg/Chevron.vue";
import Container from '@/Components/Base/Container.vue';

export default {
    components: { Container, Chevron, Link},
    props: {
        items: {
            type: Array,
            required: true
        }
    }
}
</script>
